export default __webpack_public_path__ + "static/media/pic74.3fab7454.jpg";